const localStorageKey = 'hasDoneOnboarding';

export function markHasDoneOnboarding() {
    localStorage.setItem(localStorageKey, 'true');
}

export function hasDoneOnboarding() {
    return localStorage.getItem(localStorageKey) === 'true';
}
